var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 40,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" Copy Images "),
              ]
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Quote No.")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.quoteNo,
                      expression: "quoteNo",
                    },
                    { name: "focus-inserted", rawName: "v-focus-inserted" },
                  ],
                  staticClass: "input",
                  attrs: { placeholder: "Start typing to search..." },
                  domProps: { value: _vm.quoteNo },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.quoteNo = $event.target.value
                      },
                      _vm.searchQuote,
                    ],
                  },
                }),
                _vm.validQuote
                  ? _c("span", { staticClass: "help is-success" }, [
                      _vm._v("Valid Quote No."),
                    ])
                  : _vm.quoteNo.length > 0
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Invalid Quote No."),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-success tooltip",
                  attrs: {
                    "data-tooltip": "Start copying images",
                    disabled: !_vm.validQuote,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.copy()
                    },
                  },
                },
                [_vm._v("Start Copying")]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: { "data-tooltip": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }